'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PickupBranchSelect = require('./components/PickupBranchSelect.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PickupBranchSelect).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-pickup-branch-select/lib/index.js
// module id = 547
// module chunks = 1